/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function useMutationObserver(
  target: () => HTMLElement,
  cb: MutationCallback,
  options?: MutationObserverInit,
): void {
  $effect(() => {
    const observer = new MutationObserver(cb);
    observer.observe(target(), options);
    return () => observer.disconnect();
  });
}
